import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next"; // Import I18nextProvider
import i18n from "./i18n"; // Import your i18n configuration

// Import your styles
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/css/fontawesome-all.min.css";
import "./assets/css/react-odometer-theme.css";
import "./assets/css/default.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";

import "bootstrap/dist/js/bootstrap.bundle.min";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18n}>
    {" "}
    {/* Wrap the app with I18nextProvider */}
    <BrowserRouter>
      {/* Optionally, you can place LanguageSwitcher in a header or navbar component */}
      {/* <LanguageSwitcher /> */}
      <App />
    </BrowserRouter>
  </I18nextProvider>
);
